import React, { useContext } from 'react'
import styled from 'styled-components'
import { Footer, ProfileIcon, ThemeWrapper, SideNav } from 'components'
import nologo from 'images/nologo.png'
import { reactLocalStorage } from 'reactjs-localstorage'
import { I18nContext } from 'i18n'
import { device } from 'utils/device'
import { useCount } from 'hooks/scholarshipsStage/useCount'
import { STAGED_STATUS } from 'utils/constants'
import { useLinks } from 'hooks/useLinks'

const DataCenterLayout = (props) => {
  useLinks()
  const { organization } = reactLocalStorage.getObject('user')
  const logo = organization?.logoURL
  const { component: Component, title, about, subsection: Subsection } = props
  const { translate } = useContext(I18nContext)
  const { stagedCount, getStagedCount } = useCount({
    status: [
      STAGED_STATUS.MEMBER_DRAFTING,
      STAGED_STATUS.SUBMITTED_FOR_REVIEW,
      STAGED_STATUS.PENDING_REVIEW,
    ],
  })

  return (
    <ThemeWrapper>
      <Container>
        <SideNav
          about={translate(about)}
          stagedCount={stagedCount?.meta?.itemsCount}
        />
        <Main>
          <StyledHeader>
            <Title>DATA CENTER</Title>
            <Actions>
              <ProfileIcon />
              <Logo src={logo || nologo} alt="logo" />
            </Actions>
          </StyledHeader>
          <PageTitle>{title}</PageTitle>
          <Content>
            <Component
              {...props}
              stagedCount={stagedCount?.meta?.itemsCount}
              getStagedCount={getStagedCount}
            />
          </Content>
          {Subsection && (
            <StyledSubsection>
              <Subsection getStagedCount={getStagedCount} />
            </StyledSubsection>
          )}
        </Main>
      </Container>
      <Footer dataCenter></Footer>
    </ThemeWrapper>
  )
}

const StyledSubsection = styled.div`
  background-color: white;
  -webkit-box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.25);
  margin-top: 1rem;

  @media ${device.mobileL} {
    display: none;
  }
`

const Main = styled.main`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  @media ${device.mobileL} {
    margin-left: 4rem;
  }
`

const Logo = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  margin-left: 0.5rem;
  margin-right: 1rem;
`

const Actions = styled.div`
  margin-left: auto;
  display: flex;

  @media ${device.mobileL} {
    display: none;
  }
`

const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.grayscale[7]};
  display: flex;
`

const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

const PageTitle = styled.h4`
  margin-top: 1rem;
  margin-bottom: 0;
  margin-left: 2rem;
  /* font-size: 1.2rem; */
  color: ${({ theme }) => theme.palette.secondary[0]};
`

const Title = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.palette.primary[0]};
  font-weight: 600;
`

const StyledHeader = styled.header`
  background-color: ${({ theme }) => theme.header.backgroundColor};
  display: flex;
  justify-content: left;
  padding: 2rem;
  align-items: center;
  border-bottom: 0.2rem solid ${({ theme }) => theme.palette.secondary[0]};
  height: 4rem;
`

export default DataCenterLayout
